import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import * as SecureStorage from 'secure-web-storage';
import * as i0 from "@angular/core";
var secretKey = environment.secretKey;
var StorageService = /** @class */ (function () {
    function StorageService() {
        this.secureStorage = new SecureStorage(localStorage, {
            hash: function hash(key) {
                key = CryptoJS.SHA256(key, secretKey);
                return key.toString();
            },
            encrypt: function encrypt(data) {
                data = CryptoJS.AES.encrypt(data, secretKey);
                data = data.toString();
                return data;
            },
            decrypt: function decrypt(data) {
                data = CryptoJS.AES.decrypt(data, secretKey);
                data = data.toString(CryptoJS.enc.Utf8);
                return data;
            }
        });
    }
    StorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(); }, token: StorageService, providedIn: "root" });
    return StorageService;
}());
export { StorageService };
